import { render, staticRenderFns } from "./excluded-shops.vue?vue&type=template&id=97b72b44&"
import script from "./excluded-shops.vue?vue&type=script&lang=js&"
export * from "./excluded-shops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports